import React from 'react';

import './Chapters.scss';

function Chapter6() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">Understanding the Data Before It’s Too Late</h3>
      <p className="chapter__paragraph">
        The speed with which the Australian fires destroyed so many homes and lives dramatically
        highlighted the urgency of the TSI team’s work. With the help of RONIN and AWS, the
        Australasian Wildlife Genomics Group was able to reduce the time required to sequence the
        genomes of 50 species from five years to just over a year. Analyses that used to take months
        using on-premises computing can now be done in just a couple of weeks in the cloud. Analysis
        of sequencing data from over 5,000 Tasmanian devils, for example, used to take up to ten
        days to run with the team’s on-premises resources. “Running it in the cloud takes all of six
        hours,” Dr. Hogg says.
      </p>
      <p className="chapter__paragraph">
        And according to TSI team member Parice Brandies, “If you can run through a workload in a
        couple of days rather than a couple of months, you then have those couple of months to ask
        the new questions. And I think that’s the biggest advantage.”
      </p>
    </section>
  );
}

export default Chapter6;
